import { useEffect, useState } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { FiMail, FiPhone, FiMapPin } from 'react-icons/fi';
import { getFormFields } from '../api';
import { useSettings } from '../context/SettingsContext';
import { waLink } from '../components/WhatsAppFloat';
import PageWrapper from '../components/PageWrapper';
import DynamicForm from '../components/DynamicForm';
import Loader from '../components/Loader';

export default function Contact() {
  const { settings } = useSettings();
  const [fields, setFields] = useState(null);

  useEffect(() => {
    getFormFields(true).then(setFields).catch(() => setFields([]));
  }, []);

  const s = settings || {};
  const wa = waLink(s.whatsappNumber, s.whatsappMessage);

  return (
    <PageWrapper>
      <section className="section">
        <div className="container">
          <span className="eyebrow">Get in touch</span>
          <h1 className="section-title">Contact & Enquiry</h1>
          <p className="section-sub">Fill in the form below and we'll get back to you. Prefer chat? Message us on WhatsApp.</p>

          <div className="contact-grid">
            {/* Info panel */}
            <div className="flex" style={{ flexDirection: 'column', gap: 16 }}>
              {s.email && (
                <a href={`mailto:${s.email}`} className="glass flex center gap" style={{ padding: 20 }}>
                  <div className="scard__icon" style={{ margin: 0, width: 46, height: 46, fontSize: 20 }}><FiMail /></div>
                  <div><strong>Email</strong><div className="muted">{s.email}</div></div>
                </a>
              )}
              {s.phone && (
                <a href={`tel:${s.phone}`} className="glass flex center gap" style={{ padding: 20 }}>
                  <div className="scard__icon" style={{ margin: 0, width: 46, height: 46, fontSize: 20 }}><FiPhone /></div>
                  <div><strong>Phone</strong><div className="muted">{s.phone}</div></div>
                </a>
              )}
              {s.address && (
                <div className="glass flex center gap" style={{ padding: 20 }}>
                  <div className="scard__icon" style={{ margin: 0, width: 46, height: 46, fontSize: 20 }}><FiMapPin /></div>
                  <div><strong>Address</strong><div className="muted">{s.address}</div></div>
                </div>
              )}
              {wa && (
                <a href={wa} target="_blank" rel="noreferrer" className="btn btn-block" style={{ background: 'var(--whatsapp)', color: '#fff' }}>
                  <FaWhatsapp /> Chat on WhatsApp
                </a>
              )}
            </div>

            {/* Form */}
            <div className="glass" style={{ padding: 28 }}>
              {fields === null ? <Loader /> : <DynamicForm fields={fields} source="contact" single />}
            </div>
          </div>
        </div>
      </section>
    </PageWrapper>
  );
}
